import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './bottomBar.module.scss'
import { Icon, IconType, Spacer, spacerSpacing, Text } from 'DVWebNodeUI'
import { ShareModal } from './shareModal'
import { FeedbackForm } from '../feedbackForm/feedbackForm'

export interface IBottomBarProps {
  isMobile: boolean
  isPurchaseRestricted: boolean
  isRetail: boolean
  bottomBar: WpsRuntime.atv.wps.BottomBarModelProps
}

const TermsAndConditions = ({ termsText }: {termsText: WpsRuntime.atv.wps.DVString}) => (
  <div className={`avu-full-width ${st.termsAndConditions}`}>
    <Text string={termsText}/>
  </div>
)

export const BottomIconWithLink: React.StatelessComponent<{iconType : IconType}> = props => (
  <div className={st.linkWithIcon}>
    <div className={st.bottomIcon}>
      <Icon className={st.icon} use={props.iconType}/>
    </div>
    {props.children}
  </div>
)

export const BottomBarComp = ({ isMobile, isPurchaseRestricted,
                                isRetail, bottomBar }: IBottomBarProps) => {

  const shareModalProps = { isMobile, ...bottomBar }

  return (
    !isPurchaseRestricted ? (
      <div className={`dv-dp-node-bottom ${st.bottomBar}`}>
        {!global.__NATIVEAPP__ && <TermsAndConditions termsText={bottomBar.termsText}/>}
        <Spacer className={st.iconsAndFeedback} space={spacerSpacing.m}>
          <BottomIconWithLink iconType={IconType.SHARE}><ShareModal {...shareModalProps}/></BottomIconWithLink>
          {isRetail && <BottomIconWithLink iconType={IconType.EDIT}>{<FeedbackForm />}</BottomIconWithLink>}
          <BottomIconWithLink iconType={IconType.HELP}>
            <span data-automation-id="get-help-link" data-testid="get-help-link">
              <Text string={bottomBar.helpText}/>
            </span>
          </BottomIconWithLink>
        </Spacer>
      </div>
    ) : null
  )
}

export const BottomBar = BottomBarComp
